import React from 'react'
import DonationHead from './donationComponent/DonationHead';
import DonationMessage from './donationComponent/DonationMessage';
const Donation = () => {
  return (
    <div>
      <DonationHead />
      <DonationMessage />
    </div>
  )
}

export default Donation;
